import React from "react";

import {
  Anchor,
  Box,
  Button,
  FormField,
  Grommet,
  Heading,
  Paragraph,
  Text,
  TextInput
} from "grommet";
import syllable from "syllable";
import { CopyToClipboard } from "react-copy-to-clipboard";

import "./App.css";
let theme = require("./theme.js");

class App extends React.Component {
  constructor(props) {
    super();
    this.state = {
      first: "",
      second: "",
      third: "",
      valid: false,
      copied: false
    };
  }

  handleChange(e) {
    console.log(this.state.first);
    this.setState({
      valid: false,
      [e.target.name]: e.target.value.replace(/\s+$/, "")
    });

    if (syllable(this.state.first) === 5) {
      if (syllable(this.state.second) === 7) {
        if (syllable(this.state.third) === 5) {
          this.setState({ valid: true });
        }
      }
    }
  }

  render() {
    let haiku =
      this.state.first + "\n" + this.state.second + "\n" + this.state.third;

    if (this.state.copied) {
      setTimeout(
        function() {
          this.setState({ copied: false });
        }.bind(this),
        1200
      );
    }

    return (
      <Grommet theme={theme}>
        <Box
          basis="full"
          pad="medium"
          gap="small"
          margin={{ top: "large", horizontal: "auto" }}
          width={{ max: "600px" }}
        >
          <Heading margin="none">write haiku.</Heading>
        </Box>

        <Box
          direction="row"
          justify="center"
          gap="small"
          align="center"
          pad="medium"
          width={{ max: "600px" }}
          margin={{ horizontal: "auto" }}
        >
          <Box basis="full">
            <FormField error="">
              <TextInput
                onChange={this.handleChange.bind(this)}
                onBlur={this.handleChange.bind(this)}
                name="first"
                placeholder="write here"
              />
            </FormField>
          </Box>
          <Box basis="xxsmall">
            <Text
              color={
                syllable(this.state.first) < 6 ? "dark-1" : "status-critical"
              }
              as="samp"
            >
              {5 - syllable(this.state.first)}/5
            </Text>
          </Box>
        </Box>
        <Box
          direction="row"
          justify="center"
          gap="small"
          align="center"
          pad="medium"
          width={{ max: "600px" }}
          margin={{ horizontal: "auto" }}
        >
          <Box basis="full">
            <FormField error="">
              <TextInput
                onChange={this.handleChange.bind(this)}
                onBlur={this.handleChange.bind(this)}
                name="second"
                placeholder="then here"
              />
            </FormField>
          </Box>
          <Box basis="xxsmall">
            <Text
              color={
                syllable(this.state.second) < 8 ? "dark-1" : "status-critical"
              }
              as="samp"
            >
              {7 - syllable(this.state.second)}/7
            </Text>
          </Box>
        </Box>
        <Box
          direction="row"
          gap="small"
          align="center"
          pad="medium"
          width={{ max: "600px" }}
          margin={{ horizontal: "auto" }}
        >
          <Box align="stretch" basis="full">
            <FormField error="">
              <TextInput
                onChange={this.handleChange.bind(this)}
                onBlur={this.handleChange.bind(this)}
                name="third"
                placeholder="and finaly here"
              />
            </FormField>
          </Box>
          <Box basis="xxsmall">
            <Text
              color={
                syllable(this.state.third) < 6 ? "dark-1" : "status-critical"
              }
              as="samp"
            >
              {5 - syllable(this.state.third)}/5
            </Text>
          </Box>
        </Box>
        <Box
          basis="full"
          pad="medium"
          width={{ max: "600px" }}
          margin={{ horizontal: "auto" }}
        >
          <CopyToClipboard
            text={haiku}
            onCopy={() => this.setState({ copied: true })}
          >
            <Button
              size="large"
              color="brand"
              disabled={this.state.valid ? false : true}
              primary
              label={this.state.copied ? "Copied" : "Copy to clipboard"}
              onClick={() => {}}
            />
          </CopyToClipboard>
        </Box>
        <Box
          basis="full"
          pad="medium"
          width={{ max: "600px" }}
          margin={{ horizontal: "auto" }}
        >
          <Paragraph>A minimal, syllable counting note pad.</Paragraph>
          <Paragraph>
            Built in React, using Grommet 2.0, Space Mono &amp; Staatliches.
          </Paragraph>
          <Paragraph>
            <Anchor href="https://philsn.co.uk" primary label="philsn.co.uk" />
          </Paragraph>
        </Box>
      </Grommet>
    );
  }
}

export default App;
